import { ALL_PAISES } from './PaisesReducer';
import { allPaisesService } from './PaisesService';

export const allPaisesAction = async (dispatch) => {
  try {
    const res = await allPaisesService();
    if (res.status === 200) {
      dispatch({
        type: ALL_PAISES,
        payload: res.data,
      });
      return true;
    }
  } catch (e) {
    console.log(e.message);
  }
};
